import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import DefaultCheckmark from './Checkmark/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Checkbox(props) {
  const {
    label,
    tooltip,
    checkmark: Checkmark = DefaultCheckmark,
    className: classNameFromProps,
    value,
    disabled,
    readOnly,
    onChange,
    checkmarkClassName,
    labelContainerClassName,
    indeterminate,
    uiMode,
    name,
    spacing = 'comfortable',
    ...otherProps
  } = props;
  const handleChange = useCallback(e => {
    const v = e.currentTarget.checked;
    onChange(v, name);
  }, [name, onChange]);
  const themeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);

  const className = _cs(styles.checkbox, classNameFromProps, indeterminate && styles.indeterminate, !indeterminate && value && styles.checked, disabled && styles.disabled, readOnly && styles.readOnly, spacingToStyleMap[spacing], themeClassName);

  return /*#__PURE__*/React.createElement("label", {
    // eslint-disable-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for
    className: className,
    title: tooltip
  }, /*#__PURE__*/React.createElement(Checkmark, {
    className: _cs(checkmarkClassName, styles.checkmark),
    value: value ?? false,
    indeterminate: indeterminate,
    uiMode: uiMode
  }), /*#__PURE__*/React.createElement("input", _extends({
    onChange: handleChange,
    className: styles.input,
    type: "checkbox",
    checked: value ?? false,
    disabled: disabled || readOnly
  }, otherProps)), label && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.label, labelContainerClassName)
  }, label));
}

var Checkbox$1 = genericMemo(Checkbox);

export { Checkbox$1 as default };
//# sourceMappingURL=index.js.map
